import graphql__96eb1c36e7e02de25564 from "./__generated__/AnswerFile_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import FileField from "../Form/Field/FileField";

const AnswerFile = props => {
  const {
    sourcesAttachmentToken,
    sources: files,
    formField
  } = useFragment(AnswerFile_answer, props.answer);

  const { fieldName, label, required, hint, hintPosition, multiple, maxFiles, hide } =
    formField;

  const { parent } = props;

  return (
    <FileField
      fieldName={fieldName}
      label={label}
      required={required}
      parent={parent}
      hint={hint}
      hintPosition={hintPosition}
      hide={hide}
      multiple={multiple}
      maxFiles={maxFiles}
      defaultFiles={files}
      attachmentToken={sourcesAttachmentToken}
    />
  );
};

const AnswerFile_answer = graphql__96eb1c36e7e02de25564;

export default AnswerFile;
